import { Component, EventEmitter, Input, Output } from '@angular/core';
import { sizeType } from '../../interfaces/enumSizeType';

@Component({
  selector: 'rr-badge',
  standalone: false,

  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss'
})
export class BadgeComponent {
  @Input() size: string | undefined = sizeType.Small;
  @Input() tone: string | undefined = "neutral";
  @Input() iconStart: string | undefined;
  @Input() iconEnd: string | undefined;
  @Input() type: string | undefined;

  @Output() click: EventEmitter<any> = new EventEmitter();
}
